import {lazy} from "react";

const widgets = {
    "share-price-info": lazy(() => import("./SharePriceInfo")),
    "share-price-chart": lazy(() => import("./SharePriceChart")),
}

export default widgets;